
/**
 * Method for creating operation logs entries
 * @param {String} id - representing the question id || question id plus response indices
 * @param {String} action - representing the action the user took when filling the questionnaire
 * @param {String} order - if the question has answers in a list format, we need to get the index of
 * that answer and on grid questions, we get the x,y indices
 * @returns {Object}
 */
export const createOplogEntry = (id, action, order, value) => {
  const timestamp = new Date()
  return { action, id, order, value, timestamp };
};
